import Fetch from './index'
import store from './../../store/store'
const BASE_CASE = 'https://hrpay.laway.cn/api/speed-front'
const axios = new Fetch(BASE_CASE)

export function getCaseKind (params) {
  // 获取案例分类列表
  return axios.request('get', '/professional/list', params)
}

export function getCaseList (params) {
  // 获取案例分类对应的案例列表数据
  return axios.request('get', '/cases/search', params)
}

export function getCaseDetail (id) {
  // 获取案例详情
  return axios.request('get', `/cases/detail/${id}`)
}
